import { FailedToGetData, Loading } from '../_commons';
import { meetingServices } from 'src/services';
import { millisecondsOneDay } from '@monorepo/helpers';
import { RoomCleaningTable } from '../admins-page/room-cleaning/subcomponents/RoomCleaningTable';
import { setAlertResponse } from 'src/store';
import { typeMeeting, typeMeetingsDoc } from '@monorepo/models';
import { useDispatch } from 'react-redux';
import { useEffect, useMemo, useState } from 'react';
import { useGetIsDarkMode } from 'src/custom-hooks';
import { useParams } from 'react-router';

export const FreeCleaningPage = () => {
    const params = useParams();
    //
    const [meetingsDoc, setMeetingsDoc] = useState<typeMeetingsDoc | null>(null);
    const [isLoading, setIsLoading] = useState(true);
    const congregation = parseInt(params.congregation || '0');
    const dispatch = useDispatch();
    const isDarkMode = useGetIsDarkMode();

    const meetings: typeMeeting[] = useMemo(() => {
        if (!meetingsDoc) {
            return [];
        }
        const pm = meetingsDoc.publics.filter(m => new Date(m.date).getTime() > new Date().getTime() - millisecondsOneDay) ?? [];
        const mm = meetingsDoc.midweeks.filter(m => new Date(m.date).getTime() > new Date().getTime() - millisecondsOneDay) ?? [];
        const meetings = [...pm, ...mm].sort((m1, m2) => new Date(m1.date).getTime() - new Date(m2.date).getTime());
        return meetings;
    }, [meetingsDoc]);

    useEffect(() => {
        setIsLoading(true);
        meetingServices.GetFree(congregation).then(response => {
            setIsLoading(false);
            if (!response.success || !response.data?.meetingsDoc) {
                dispatch(setAlertResponse({ response }));
                return;
            }
            setMeetingsDoc(response.data.meetingsDoc);
        });
    }, []);

    if (isLoading) {
        return <Loading mt={'120px'} />;
    }

    if (!meetingsDoc) {
        return <FailedToGetData />;
    }

    return (
        <div className={isDarkMode ? 'bg-dark text-white' : ''}>
            <RoomCleaningTable
                isEdit={false}
                meetings={meetings}
                setMeetingsToSave={() => {}}
            />
        </div>
    );
}
